import ReactVisibilitySensor from "react-visibility-sensor";
import Counter from "../Counter/Counter";
import { useContext } from "react";
import { LangContext } from "../../App";

type ColGroup = {
    label : string;
    cols : {
        number : number;
        color : string;
    }[];
}

type HorizontalChartProps = {
    colGroups : ColGroup[];
    labels : {
        name : string;
        color : string;
    }[];
    maxValue? : number;
    xAxis : string[] | number[];
}

const HorizontalChart = ({
    colGroups,
    labels,
    maxValue = 600,
    xAxis,
} : HorizontalChartProps) => {
    const { lang } = useContext(LangContext);

  return (
    <div className={`horizontal-chart ${lang ? "rtl" : ""}`}>
        {colGroups.map((item, index) => (
            <ReactVisibilitySensor
                partialVisibility
            >
            {({isVisible} : any) => (
            <>
            <div key={index} className="group-wrapper">
            <p className="label">{item.label}</p>
            <div className="col-group">
                {item.cols.map((itemTwo, indexTwo) => (
                    <div className={`col-wrapper ${isVisible ? "visible" : ""}`}>
                    <div 
                        key={indexTwo} 
                        className={`col bg-${itemTwo.color}`}
                        style={{ width: `${itemTwo.number * 100 / maxValue}%`}}
                    >
                        <Counter counterValue={itemTwo.number} applyCounteClassName="" />
                        
                    </div>
                    </div>
                ))}
            </div>
            </div>
            </>
            )}
            </ReactVisibilitySensor>
        ))}
        <div className="x-axis">
            {xAxis.map((item, index) => (
                <span key={index} className="x-label">{item}</span>
            ))}
        </div>

        <div className="chart-keys-container">
            {labels.map((item, index) => (
                <div key={index} className="chart-key">
                    <div className={`color-box bg-${item.color}`}></div>
                    <span className="key-name">{item.name}</span>
                </div>
            ))}
        </div>
    </div>
  )
}

export default HorizontalChart